<template>
  <b-row>
    <b-col cols="12">
      <email-tester-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EmailTesterContent from './EmailTesterContent.vue'

export default {
  components: {
    BRow,
    BCol,

    EmailTesterContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>